<template lang='pug' src="./order-history.pug"> </template>
<style lang="scss" src="./order-history.scss"> </style>

<script>
import { mapState, mapGetters } from 'vuex';
import infoOrder from '@/views/pages/ReceiveOrders/info-order';
import  helpers from '@/utils/helpers';

export default {
    components: {
        'v-info-order': infoOrder
    },
    props: {
        order: {
            type: Object,
            required: true
        },
        activeOrder: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        isShowDetails: false,
        orderHistoryDialog: false
    }),
    computed: {
        ...mapGetters(['user']),
        ...mapState({
            orderHistories: (state) => state.orders.orderHistories
        }),
        formattedOptions: function() {
            return this.order.orderOptions.map('optionName').join(', ');
        },
        formattedOperator: function() {
            return !(this.user && this.user.id === this.order && this.order.operator && this.order.operator.id);
        },
        canReplaceOrder() {
            const statuses = ['completed', 'landed'];
            return !this.activeOrder.cancelReason && !statuses.includes(this.order.status) && !this.order.cancelReason;
        },
        sortedAddresses() {
            return helpers.sortAddresses(this.order.unorderedAddresses, this.$vuetify.lang.t('$vuetify.pages.ReceiveOrders.noAddress'));
        },
    },
    methods: {
        toggleDetails() {
            this.isShowDetails = !this.isShowDetails;
        },
        toggleOrderHistoryDialog() {
            if(this.canReplaceOrder) {
                this.orderHistoryDialog = !this.orderHistoryDialog;
            }
        },
        replaceOrder() {
            this.orderHistoryDialog = false;
            this.$emit('onReplaceOrder', this.order);
        }
    }
};
</script>
